export enum CommonLabelsEnum {
    YES = 'Yes',
    NO = 'No',
}

export const MODAL_DURATION = 5000;